import React from 'react';

function EntitiesButtonComp(props) {
  return (
    <div className='gap-6 p-3 '>
        <button   className='flex flex-column w-4/5 bg-slate-100 p-2  ' onClick={props.onClick}>
          <div className={'container  flex m-auto gap-4'}>
            <img src={props.image} width={80} />
            <p className='m-auto'>{props.name}</p>
          </div>
        </button>
    </div>
  );
}

export default EntitiesButtonComp;